/* __next_internal_client_entry_do_not_use__ SDUIBrandTileRenderer auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { LeanBrandTileRendererForCarousel } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/LeanBrandTileRendererForCarousel";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { getQueryParamsForSurface } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/tileUrlHelpers";
import React, { useCallback, useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
export var SDUIBrandTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var on_click = tileElement.on_click;
    var _tileElement_brand_tile;
    var brand = ((_tileElement_brand_tile = tileElement.brand_tile) !== null && _tileElement_brand_tile !== void 0 ? _tileElement_brand_tile : {}).brand;
    var leanBrandTile = useMemo(function() {
        return ILeanBrandTile.fromIBrandTile(brand);
    }, [
        brand
    ]);
    var location = useZustandLocation(function(state) {
        return state.search;
    });
    var match = useRouteMatch();
    var brandTileQueryParams = useCallback(function() {
        if (loggingData.view_display_page === undefined) {
            return {};
        }
        return getQueryParamsForSurface(loggingData.view_display_page, location, match);
    }, [
        loggingData,
        location,
        match
    ]);
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        children: /*#__PURE__*/ _jsx(LeanBrandTileRendererForCarousel, {
            leanBrandTile: leanBrandTile,
            brandPageQueryParams: brandTileQueryParams
        })
    });
};
